import React from "react";
import { CONSTANT } from "../../../constants/constants";
import { t } from "i18next";
import FormRadioCheckboxField from "../../form/form-radio-field";

const FormOptionalRegistrationTypeField = (props) => {
  const {
    feesList,
    handleOptionalRegChange,
    setFieldValue,
    conferenceDetails,
  } = props;

  return (
    <>
      {feesList?.length > 0 && (
        <>
          <h6 className="mb-3 color-brand">
            {t("select-optional-subscription")}
          </h6>
          {feesList.map((fee, index) => {
            return (
              !fee?.isMandatory && (
                <div className="form-check" key={index}>
                  {conferenceDetails?.allowMultipleOpts ? (
                    <FormRadioCheckboxField
                      label={fee?.subscriptionKey}
                      fieldId={fee?.subscriptionKey + index}
                      fieldName={fee?.subscriptionKey}
                      type="checkbox"
                      handleChange={(event) =>
                        handleOptionalRegChange(
                          event,
                          setFieldValue,
                          fee?.subscriptionKey
                        )
                      }
                    />
                  ) : (
                    <FormRadioCheckboxField
                      label={fee?.subscriptionKey}
                      fieldId={CONSTANT.OPTIONAL_SUBSCRIPTION_RADIO + index}
                      fieldName={CONSTANT.OPTIONAL_SUBSCRIPTION_RADIO}
                      value={fee?.subscriptionKey}
                      type="radio"
                      handleChange={(event) =>
                        handleOptionalRegChange(event, setFieldValue)
                      }
                    />
                  )}
                </div>
              )
            );
          })}
        </>
      )}
    </>
  );
};

export default FormOptionalRegistrationTypeField;
